import { DataSharingEnums, DataSharingQuery } from 'dashboard-services/api/dataSharing';
import { ReduxService } from 'dashboard-services/services';

import properties from 'resources/constants/properties.json';

import { useQuery } from '@tanstack/react-query';

export default (() => {

  const LOCAL_PROVIDER = {
    name: undefined,
    readableName: "Local",
    state: DataSharingEnums.PROVIDER_STATE.ACTIVE,
    apiUrl: undefined,
    iconUrl: properties.logoUrl,
    type: undefined,
    producerId: undefined
  }

  const fillMissingFromLocal = producer => {
    const merged = { ...producer }
    Object.keys(LOCAL_PROVIDER).forEach(key => {
      if(!ReduxService.nonNullOrUndefined(merged[key])) {
        merged[key]=LOCAL_PROVIDER[key]
      }
    })
    return merged;
  }

  const onSelect = ({ producers = [], alwaysReturnProducer } = {}) => {
    if(producers.length > 0) {
      const localProducerIndex = producers.findIndex(producer => producer.producerId === 0)
      if(localProducerIndex > -1) {
        const producersWIthMergedLocal = producers.replace(fillMissingFromLocal(producers[localProducerIndex]), localProducerIndex)
        return producersWIthMergedLocal
      }
      return [LOCAL_PROVIDER].concat(producers);
    } else {
      return alwaysReturnProducer ? [LOCAL_PROVIDER] : undefined
    }
  }

  const useGetProducers = ({ getQueryBuilder, includeSelfProducer = false, alwaysReturnProducer = false, ...rest }) => useQuery({
    ...DataSharingQuery.QUERIES.getProducers(
      getQueryBuilder,
      {
        includeSelfProducer,
      }
    ),
    select: response => onSelect({ alwaysReturnProducer, ...response }),
    enabled: properties?.["sharing_enabled"] === "true",
    ...rest
  })

  return {
    useGetProducers,
    LOCAL_PROVIDER
  }
})()